import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { nocModeSelector, greenBarEnabledSelector } from '@store/noc/base/selectors';
import { drilldown as trendDrilldown } from '@store/noc/trendsData/actions';
import { drilldown as filterDrilldown } from '@store/noc/filtersData/actions';
import { NOC_MODE_TRENDS, INTERNAL_UNKNOWN } from '@utils/constants';
import get from 'lodash/get';
import { THRESHOLD_GOOD } from '../utils';
import { RealtimeTileWrapper } from './styled';
import { BarTile } from './BarTile';

const Cell = ({ cellData, unit, column, rowData, max = 0 }) => {
  const dispatch = useDispatch();
  const mode = useSelector(nocModeSelector);
  const greenBarEnabled = useSelector(greenBarEnabledSelector);
  const navigate = useNavigate();
  const metric = column.key;
  const drilldown = mode === NOC_MODE_TRENDS ? trendDrilldown : filterDrilldown;
  const thresholdCategory = get(rowData, ['threshold', metric, 'category'], THRESHOLD_GOOD);
  const metricThreshold = get(rowData, ['threshold', metric, 'metricThreshold'], null);

  // warmup scenario
  if (rowData.warmup) {
    return null;
  }

  // drilldown action
  function handleClick() {
    // drilldown is not supported on unknown
    if (rowData.id === INTERNAL_UNKNOWN || rowData.isTotalRow) {
      return;
    }
    dispatch(
      drilldown({
        metric,
        row: rowData,
        navigate,
      }),
    );
  }

  return (
    <RealtimeTileWrapper>
      <BarTile
        greenBarEnabled={greenBarEnabled}
        isTotal={rowData.isTotalRow}
        category={thresholdCategory}
        value={cellData}
        unit={unit}
        max={max}
        threshold={metricThreshold}
        onClick={handleClick}
      />
    </RealtimeTileWrapper>
  );
};

export default React.memo(Cell);
